import { useState } from "react";
import ImageUploadModal from "./modals/ImageUploadModal";
import { Button, Image } from "antd";
import RemoveIcon from "./images/Remove";
import PlusIcon from "./images/Plus";
import ApiService from "../utils/ApiService";
import useUserStore from "../stores/store";

export default function UploadThumbnailComponent({
                                                   setImage,
                                                   placeholderText,
                                                   key_id = "",
                                                   isSubmitted = false,
                                                   bannerId = "",
                                                   banners = [],
                                                   prevImage = "",
                                                   aspect = 1 / 1,
                                                   context = "",
                                                   deleteParams = null
                                                 }) {
  const defaultImage = "/images/temp-res-logo2.png";
  const { user, showNotification } = useUserStore();
  const [isImageUploadModalOpen, setIsImageUploadModalOpen] = useState(false);

  // initialize fileList with prevImage or empty
  const [fileList, setFileList] = useState(
    prevImage
      ? [
        {
          uid: "initial-file",
          name: "previous-image",
          status: "done",
          url: prevImage,
        },
      ]
      : []
  );

  function handleImageUploadModal() {
    setIsImageUploadModalOpen(!isImageUploadModalOpen);
  }

  async function onHandleImageModalOkButton() {
    if (fileList.length === 0) {
      setIsImageUploadModalOpen(false);
      return;
    }

    const chosenFile = fileList[0];
    const imageBlob =
      chosenFile.originFileObj instanceof Blob
        ? chosenFile.originFileObj
        : null;

    if (bannerId === "") {
      setImage(imageBlob);
    } else {
      // works as a list
      const tempBannerObj = banners.find((banner) => banner.id === bannerId);
      const currentObjIndex = banners.findIndex(
        (banner) => banner.id === bannerId
      );

      setImage((prevImages) => {
        if (
          Boolean(tempBannerObj) &&
          tempBannerObj.id !== "" &&
          tempBannerObj.image === ""
        ) {
          const tempObj = {
            id: tempBannerObj.id,
            image: imageBlob,
          };

          const tempNewBanners = [...prevImages, tempObj];

          const newBanners = Array.from(
            tempNewBanners
              .reduce((map, item) => {
                if (map.has(item.id)) {
                  const existing = map.get(item.id);
                  if (!existing.image) map.set(item.id, item);
                } else {
                  map.set(item.id, item);
                }
                return map;
              }, new Map())
              .values()
          );
          return newBanners;
        }
        if (tempBannerObj.id !== "" && tempBannerObj.image !== "") {
          const tempObj = {
            id: tempBannerObj.id,
            image: imageBlob,
          };

          banners[currentObjIndex].id = tempObj.id;
          banners[currentObjIndex].image = tempObj.image;
          return banners;
        }
      });
    }

    setIsImageUploadModalOpen(false);
  }

  function onHandleImageModalCancelButton() {
    setIsImageUploadModalOpen(false);
  }

  async function onHandleRemoveImage() {
    console.log("deleteParams: ", deleteParams);
    console.log("bannerId: ", bannerId);
    setFileList([]); // clear preview

    // Handle banner image removal for add or edit both
    if (bannerId) {
      console.log("Removing banner image with ID: ", bannerId);
      setImage((prevBanners) =>
        prevBanners ? prevBanners.filter((b) => b.id !== bannerId) : []
      );
      // Network call to delete banner image if deleteParams provided
      if (deleteParams?.modelId) {
        console.log("Network call to delete banner image with params: ");
        await deleteImageFromServer(true);
      }
      return;
    }

    // Handle single image removal with optional server delete
    if (!deleteParams?.modelId) {
      console.log("No deleteParams provided, clearing image.");
      setImage(null); // reset parent
    }else {
      await deleteImageFromServer();
    }
  }

  const deleteImageFromServer = async (isBanner=false) => {
    try {
      console.log("Going to delete image with params: ", deleteParams);
      const response = await ApiService.ADMIN_FILE_DELETE(
        deleteParams,
        user.token.token
      );

      if (response.code !== 200) {
        showNotification(response.data.message || "Couldn't delete the file.");
        throw new Error("Couldn't delete the file.");
      }

      showNotification("Image deleted successfully.", false);
      if (!isBanner) setImage(null);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <section key={key_id}>
      <div className="flex">
        <div
          className="flex w-full relative bg-white rounded-l-lg
        border-t border-t-[1px] border-t-[#D5D8DB]
        border-l border-l-[1px] border-l-[#D5D8DB]
        border-b border-b-[1px] border-b-[#D5D8DB] h-[48px]"
        >
          <div className="absolute top-[25%] left-[7%] w-full truncate text-[#828282]">
            {placeholderText}
          </div>
        </div>
        <Button
          className="flex items-center justify-center w-14 cursor-pointer h-[48px]"
          disabled={fileList.length > 0} // disable if already chosen
          onClick={handleImageUploadModal}
          style={{
            backgroundColor: "#FCBD10",
            color: "white",
            borderTopRightRadius: "0.5rem",
            borderBottomRightRadius: "0.5rem",
            borderTopLeftRadius: "0",
            borderBottomLeftRadius: "0",
            borderColor: "#D5D8DB",
            borderWidth: "0px",
          }}
        >
          <PlusIcon
            attributes={{
              color: "#ffffff",
              size: "16",
            }}
          />
        </Button>
      </div>

      {/* Always show a preview (default or chosen) */}
      {!isSubmitted && (
        <div className="mt-[10px] text-center flex justify-center space-x-[5px]">
          {fileList.length > 0 ? (
            fileList.map((file) => (
              <div key={file.uid} className="relative">
                <Image
                  src={file.url || file.thumbUrl}
                  alt={file.name}
                  width={100}
                  fallback={defaultImage}
                  className="rounded-lg"
                />
                <div className="absolute top-1 right-1">
                  <RemoveIcon
                    attributes={{
                      color: "#EE3169",
                      size: "20",
                      classes: "cursor-pointer",
                    }}
                    clickHandler={onHandleRemoveImage}
                  />
                </div>
              </div>
            ))
          ) : (
            <div className="relative">
              <Image
                src={defaultImage}
                alt="default"
                width={100}
                className="rounded-lg"
              />
            </div>
          )}
        </div>
      )}

      <ImageUploadModal
        openModal={isImageUploadModalOpen}
        handleOk={onHandleImageModalOkButton}
        handleCancel={onHandleImageModalCancelButton}
        records={{
          titleText: placeholderText,
          fileList: fileList,
          setFileList: setFileList,
          setCroppedFile: () => {}, // no longer used
          setClose: setIsImageUploadModalOpen,
        }}
        aspect={aspect}
        context={context}
      />
    </section>
  );
}
